import { isDev } from "@memorang/constants";
import type { IconType } from "@memorang/ui";
import type { TFunction } from "i18next";
import { Apps } from "types/apps";
import { tagIconMap } from "./demo";

const rankStyles = [
	// Gold
	{
		podiumBg: "rgb(255, 224, 131)",
		textColor: "rgb(35, 27, 0)",
		height: 156,
		marginTop: 16,
		avatarSize: 56,
	},
	// Silver
	{
		podiumBg: "rgb(219, 228, 230)",
		height: 128,
		textColor: "rgb(47, 21, 0)",
		marginTop: 16,
		avatarSize: 48,
	},
	// Bronze
	{
		podiumBg: "rgb(255, 220, 195)",
		textColor: "rgb(47, 21, 0)",
		height: 112,
		marginTop: 16,
		avatarSize: 40,
	},
];

const isScreenshotMode = true;

export const testRedeemableProducts = [
	{
		id: "123",
		icon: "https://memorang-prod-icon.s3.amazonaws.com/icon/icon_bundle_45.png",
		title: "NCLEX-RN",
		description: "Study-Pack",
		codes: ["1234", "12345"],
		bundleType: "PRACTICE_TEST",
	},
];

export const blackListedStudypackIdsForWeb = [
	"ec813a37-bb72-43fb-8435-e161bf29f15d",
	"7d2cf2cf-5d2e-4b16-b9f1-9d7cf8c29876",
	"1f3d229e-4dbd-4762-966e-e3eae1d4b13b",
	"335f06bc-a8ac-4359-86bc-b2e96c2476a9",
];

export const getMasteryLabels = (t: TFunction) => ({
	low: t("mastery.labels.low"),
	medium: t("mastery.labels.medium"),
	high: t("mastery.labels.high"),
	none: t("mastery.labels.none"),
});

export const defaultMasteryLabels = {
	low: "Needs work",
	medium: "Almost there",
	high: "Mastered",
	none: "Not answered",
};

export const appConfigIds: Record<
	string,
	{
		collectionId: number;
		projectId: number;
		organizationId: number;
		productId: number;
		productUuid: string;
	}
> = {
	[Apps.Proethica]: {
		collectionId: 745,
		projectId: isDev ? 61 : 47,
		organizationId: isDev ? 29 : 24,
		productId: 178,
		productUuid: "89891e30-96c3-4298-b90d-da5fc7db627b",
	},
};

const skillIconMap: Record<string, IconType> = {
	Writing: "file-document-edit-outline",
	写作: "file-document-edit-outline",
	Listening: "ear-hearing",
	听力: "ear-hearing",
	Speaking: "microphone-outline",
	口语: "microphone-outline",
	Reading: "book-open-page-variant-outline",
	阅读: "book-open-page-variant-outline",
	"Reading & Listening": "book-open-page-variant-outline",
	"Speaking & Writing": "microphone-outline",
	...tagIconMap,
};
export { rankStyles, isScreenshotMode, skillIconMap };
